// Tech stack icon URLs using cdn.jsdelivr.net/gh/devicons
const DEVICON = "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons";

const techIcons = {
  // Mobile
  "Swift": `${DEVICON}/swift/swift-original.svg`,
  "SwiftUI": `${DEVICON}/swift/swift-original.svg`,
  "Kotlin": `${DEVICON}/kotlin/kotlin-original.svg`,
  "Jetpack Compose": `${DEVICON}/jetpackcompose/jetpackcompose-original.svg`,
  "React Native": `${DEVICON}/react/react-original.svg`,
  "Flutter": `${DEVICON}/flutter/flutter-original.svg`,
  "Dart": `${DEVICON}/dart/dart-original.svg`,
  "Firebase": `${DEVICON}/firebase/firebase-original.svg`,
  "AWS Amplify": `${DEVICON}/amazonwebservices/amazonwebservices-plain-wordmark.svg`,
  "GraphQL": `${DEVICON}/graphql/graphql-plain.svg`,
  "REST APIs": `${DEVICON}/fastapi/fastapi-original.svg`,
  "Core Data": `${DEVICON}/apple/apple-original.svg`,

  // Web
  "React": `${DEVICON}/react/react-original.svg`,
  "Angular": `${DEVICON}/angular/angular-original.svg`,
  "Vue.js": `${DEVICON}/vuejs/vuejs-original.svg`,
  "Next.js": `${DEVICON}/nextjs/nextjs-original.svg`,
  "Node.js": `${DEVICON}/nodejs/nodejs-original.svg`,
  "Python": `${DEVICON}/python/python-original.svg`,
  "TypeScript": `${DEVICON}/typescript/typescript-original.svg`,
  "PostgreSQL": `${DEVICON}/postgresql/postgresql-original.svg`,
  "MongoDB": `${DEVICON}/mongodb/mongodb-original.svg`,
  "Redis": `${DEVICON}/redis/redis-original.svg`,
  "AWS": `${DEVICON}/amazonwebservices/amazonwebservices-plain-wordmark.svg`,
  "Docker": `${DEVICON}/docker/docker-original.svg`,

  // Custom Software
  ".NET": `${DEVICON}/dot-net/dot-net-original.svg`,
  "Java": `${DEVICON}/java/java-original.svg`,
  "Go": `${DEVICON}/go/go-original.svg`,
  "Rust": `${DEVICON}/rust/rust-original.svg`,
  "C++": `${DEVICON}/cplusplus/cplusplus-original.svg`,
  "Kubernetes": `${DEVICON}/kubernetes/kubernetes-original.svg`,
  "Terraform": `${DEVICON}/terraform/terraform-original.svg`,
  "Azure": `${DEVICON}/azure/azure-original.svg`,
  "GCP": `${DEVICON}/googlecloud/googlecloud-original.svg`,

  // E-commerce
  "Shopify": `${DEVICON}/shopify/shopify-original.svg`,
  "WooCommerce": `${DEVICON}/woocommerce/woocommerce-original.svg`,
  "Magento": `${DEVICON}/magento/magento-original.svg`,
  "Stripe": `${DEVICON}/stripe/stripe-original.svg`,
  "Elasticsearch": `${DEVICON}/elasticsearch/elasticsearch-original.svg`,
  "Algolia": `${DEVICON}/algolia/algolia-original.svg`,

  // AI/ML
  "TensorFlow": `${DEVICON}/tensorflow/tensorflow-original.svg`,
  "PyTorch": `${DEVICON}/pytorch/pytorch-original.svg`,
  // Devicon does not provide an OpenAI icon yet; let UI fallback render a styled initial
  "OpenAI": null,
  "LangChain": `${DEVICON}/python/python-original.svg`,
  "Hugging Face": `${DEVICON}/python/python-original.svg`,
  "Scikit-learn": `${DEVICON}/scikitlearn/scikitlearn-original.svg`,
  "Pandas": `${DEVICON}/pandas/pandas-original.svg`,
  "AWS SageMaker": `${DEVICON}/amazonwebservices/amazonwebservices-plain-wordmark.svg`,
  "MLflow": `${DEVICON}/python/python-original.svg`,
  "FastAPI": `${DEVICON}/fastapi/fastapi-original.svg`,
  "JavaScript": `${DEVICON}/javascript/javascript-original.svg`,
};

export function getTechIcon(name) {
  return techIcons[name] || null;
}

export default techIcons;
